import { useMemo } from 'react'

let DEFAULT_SETTINGS = {
  slot_interval: 5,
  hipaa: false,
  selected_appointment_templates: [],
  blue_bar_range: { before: 4, after: 4 },
  full_day_default: false,
  patient_default: 'new',
}

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    let user_settings = data?.calendar_user_settings?.[0]
    let location_settings = data?.calendar_location_settings?.[0]
    let public_user_preferences = data?.user_preferences?.[0]

    if (!user_settings) {
      user_settings = {}
    }

    if (!location_settings) {
      location_settings = {}
    }

    if (!public_user_preferences) {
      public_user_preferences = {}
    }

    return {
      slot_interval:
        user_settings.slot_interval ?? DEFAULT_SETTINGS.slot_interval,
      full_day_default:
        location_settings.full_day_default ?? DEFAULT_SETTINGS.full_day_default,
      patient_default:
        location_settings.patient_default ?? DEFAULT_SETTINGS.patient_default,
      hipaa: public_user_preferences.hipaa ?? DEFAULT_SETTINGS.hipaa,
      selected_appointment_templates:
        user_settings.selected_appointment_templates ??
        DEFAULT_SETTINGS.selected_appointment_templates,
      blue_bar_range:
        location_settings.blue_bar_range ?? DEFAULT_SETTINGS.blue_bar_range,
      // The default value for chairs_in_view is not set here.
      // It is set in the next level when we have knowledge
      // about the total number of chairs present in the clinic
      chairs_in_view: user_settings.chairs_in_view,
    }
  }, [data])
}
